import { render } from "./QueueDisplay.vue?vue&type=template&id=2e35830e&scoped=true"
import script from "./QueueDisplay.vue?vue&type=script&lang=js"
export * from "./QueueDisplay.vue?vue&type=script&lang=js"

import "./QueueDisplay.vue?vue&type=style&index=0&id=2e35830e&lang=css"
import "./QueueDisplay.vue?vue&type=style&index=1&id=2e35830e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e35830e"]])

export default __exports__